(function() {
  'use strict';

  var SEEN_KEY = 'moinbello_popup_seen';
  var CONVERTED_KEY = 'moinbello_popup_converted';
  var DELAY_MS = 15000;
  var SUPPRESS_DAYS = 30;

  var popup = document.getElementById('newsletter-popup');
  if (!popup) return;

  // Check if already converted — never show again
  try {
    if (localStorage.getItem(CONVERTED_KEY)) return;

    // Check if seen recently
    var seen = localStorage.getItem(SEEN_KEY);
    if (seen) {
      var elapsed = Date.now() - parseInt(seen, 10);
      if (elapsed < SUPPRESS_DAYS * 24 * 60 * 60 * 1000) return;
    }
  } catch(e) {}

  var shown = false;
  var focusableEls;
  var firstFocusable;
  var lastFocusable;

  function show() {
    if (shown) return;
    shown = true;
    popup.classList.add('popup-visible');
    popup.setAttribute('aria-hidden', 'false');

    // Focus trap setup
    focusableEls = popup.querySelectorAll('input, button, [tabindex]:not([tabindex="-1"])');
    firstFocusable = focusableEls[0];
    lastFocusable = focusableEls[focusableEls.length - 1];

    var emailInput = document.getElementById('popup-email-input');
    if (emailInput) emailInput.focus();
  }

  function close() {
    popup.classList.remove('popup-visible');
    popup.setAttribute('aria-hidden', 'true');
    try { localStorage.setItem(SEEN_KEY, Date.now().toString()); } catch(e) {}
  }

  // Trigger: delay
  var timer = setTimeout(show, DELAY_MS);

  // Trigger: exit intent (desktop only)
  if (window.matchMedia('(pointer: fine)').matches) {
    document.addEventListener('mouseleave', function(e) {
      if (e.clientY <= 0) show();
    });
  }

  // Close: X button
  var closeBtn = popup.querySelector('.popup-close');
  if (closeBtn) closeBtn.addEventListener('click', close);

  // Close: backdrop click
  var backdrop = popup.querySelector('.popup-backdrop');
  if (backdrop) backdrop.addEventListener('click', close);

  // Close: Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && popup.classList.contains('popup-visible')) {
      close();
    }
    // Focus trap
    if (e.key === 'Tab' && popup.classList.contains('popup-visible') && focusableEls) {
      if (e.shiftKey) {
        if (document.activeElement === firstFocusable) {
          e.preventDefault();
          lastFocusable.focus();
        }
      } else {
        if (document.activeElement === lastFocusable) {
          e.preventDefault();
          firstFocusable.focus();
        }
      }
    }
  });

  // Copy button
  var copyBtn = document.getElementById('popup-copy-btn');
  if (copyBtn) {
    copyBtn.addEventListener('click', function() {
      var code = document.getElementById('popup-discount-code');
      if (code) {
        navigator.clipboard.writeText(code.textContent).then(function() {
          copyBtn.textContent = 'Kopiert!';
          setTimeout(function() { copyBtn.textContent = 'Kopieren'; }, 2000);
        }).catch(function() {
          // Fallback
          var range = document.createRange();
          range.selectNodeContents(code);
          var sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);
          copyBtn.textContent = 'Kopiert!';
          setTimeout(function() { copyBtn.textContent = 'Kopieren'; }, 2000);
        });
      }
    });
  }

  // Form submit handling
  var form = document.getElementById('popup-newsletter-form');
  if (form) {
    form.addEventListener('submit', function() {
      // Mark as converted after form submission
      try { localStorage.setItem(CONVERTED_KEY, Date.now().toString()); } catch(e) {}
    });
  }
})();
